<template>
  <div class="consider__plan__form">
    <div class="text-start mb-4">
      <div class="font-32 font-w-700 font-ch">ผลพิจารณา</div>
      <div class="font-20 font-w-700 font-ch">
        แผนงานพัฒนาขีดความสามารถทางเทคโนโลยีและวิจัยของภาคเอกชนในพื้นที่ (IRTC)
      </div>
    </div>

    <v-layout justify-end mb-4>
      <v-flex shrink mr-4>
        <v-btn color="#e51610" outlined rounded depressed>
          <Iconify
            style="color: #e51610"
            icon="fluent:document-pdf-24-filled"
          ></Iconify>
          <span style="color: #e51610">Export PDF </span>
        </v-btn>
      </v-flex>
      <v-flex shrink>
        <v-btn color="#5CB844" rounded depressed dark>
          <Iconify style="color: #fff" icon="ri:file-excel-2-fill"></Iconify>
          <span style="color: #fff">Export Excel </span>
        </v-btn>
      </v-flex>
    </v-layout>

    <v-card flat class="pa-6 section_form mb-3">
      <!-- รหัสแผนงาน -->
      <v-layout align-center class="font-14 font-w-500 font-ch mb-4">
        <v-flex xs1>
          <span class="mr-2">รหัสแผนงาน</span>
        </v-flex>
        <v-flex xs1>
          <span class="text__orange">
            {{ form?.plan?.plan_master?.plan_code }}
          </span>
        </v-flex>
        <v-flex shrink>
          <span class="text__orange">
            {{ form?.plan?.plan_master?.plan_name_th }}
          </span>
        </v-flex>
      </v-layout>

      <!-- ภูมิภาค -->
      <v-layout align-center class="font-14 font-w-500 font-ch mb-4">
        <v-flex xs1>
          <span class="mr-2">ภูมิภาค</span>
        </v-flex>
        <v-flex xs1>
          <span class="text__orange">{{ form?.region }}</span>
        </v-flex>
        <v-flex shrink>
          ผู้พิจารณา
          <span class="text__orange px-3">{{ form?.evaluators.length }} </span>
          ท่าน
        </v-flex>
      </v-layout>

      <!-- คะแนนเฉลี่ยรวม -->
      <v-layout align-center class="font-14 font-w-500 font-ch mb-4">
        <v-flex xs1>
          <span class="mr-2">คะแนนเฉลี่ยรวม</span>
        </v-flex>
        <v-flex xs1>
          <span class="text__orange"
            >{{ sumTotalScore() }}/{{
              form?.plan?.evaluate_layout?.overall_score
            }}</span
          >
        </v-flex>
      </v-layout>
    </v-card>

    <!-- Table -->
    <v-card flat class="pa-6 section_form mb-3" v-if="form">
      <table class="custom_table">
        <thead>
          <tr>
            <th
              class="text-center font-12"
              style="border-right: thin solid #d3d3d3"
              width="5%"
            >
              ลำดับ
            </th>
            <th
              class="text-center font-12"
              style="border-right: thin solid #d3d3d3"
              width="50%"
            >
              ประเภท/รายละเอียด
            </th>
            <th
              class="text-center font-12"
              style="border-right: thin solid #d3d3d3"
              width="10%"
            >
              คะเเนนเต็ม
            </th>
            <th
              class="text-center font-12 header_link"
              style="border-right: thin solid #d3d3d3"
              width="5%"
              @click="onViewConsiderForm(0)"
            >
              ผชช.1
            </th>
            <th
              class="text-center font-12 header_link"
              style="border-right: thin solid #d3d3d3"
              width="5%"
              @click="onViewConsiderForm(1)"
            >
              ผชช.2
            </th>
            <th
              class="text-center font-12 header_link"
              style="border-right: thin solid #d3d3d3"
              width="5%"
              @click="onViewConsiderForm(2)"
            >
              ผชช.3
            </th>
            <th
              class="text-center font-12 header_link"
              style="border-right: thin solid #d3d3d3"
              width="5%"
              @click="onViewConsiderForm(3)"
            >
              ผชช.4
            </th>
            <th
              class="text-center font-12 header_link"
              style="border-right: thin solid #d3d3d3"
              width="5%"
              @click="onViewConsiderForm(4)"
            >
              ผชช.5
            </th>
            <th class="text-center font-12" width="10%">ผลการประเมิน</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(item, i) in form?.plan.evaluate_layout.details"
            :key="i"
            style="vertical-align: top"
          >
            <!-- ลำดับ -->
            <td
              class="text-center py-3"
              style="
                border-right: thin solid #d3d3d3;
                border-bottom: 1px solid #d3d3d3;
              "
              width="5%"
            >
              {{ i + 1 }}.
            </td>

            <!-- ประเภท/รายละเอียด -->
            <td
              style="
                border-right: thin solid #d3d3d3;
                border-bottom: 1px solid #d3d3d3;
              "
              width="50%"
              class="py-3"
            >
              <!-- main detail -->
              <div style="height: 40px">{{ item.name }}</div>
              <!-- sub detail -->
              <div
                style="height: 50px"
                v-for="(sub, j) in item.sub_details"
                :key="j"
                class="d-flex align-center"
              >
                <div>
                  <span class="mr-2">{{ i + 1 }}.{{ j + 1 }}</span>
                  <span>{{ sub.name }}</span>
                </div>
              </div>
            </td>

            <!-- คะเเนนเต็ม -->
            <td
              class="text-center py-3"
              style="
                border-right: thin solid #d3d3d3;
                border-bottom: 1px solid #d3d3d3;
              "
              width="5%"
            >
              <!-- main detail -->
              <div style="height: 40px" class="text__orange">
                {{ item.max_score }}
              </div>
              <!-- sub detail -->
              <div
                style="height: 50px"
                v-for="(sub, j) in item.sub_details"
                :key="j"
                class="text-center d-flex align-center justify-center"
              >
                <span>{{ sub.max_score }}</span>
              </div>
            </td>

            <!-- ผชช.1 -->
            <td
              class="text-center py-3"
              style="
                border-right: thin solid #d3d3d3;
                border-bottom: 1px solid #d3d3d3;
              "
              width="5%"
            >
              <!-- main detail -->
              <div style="height: 40px">
                {{
                  form?.evaluate_forms[0]?.details[i]?.sub_details?.length == 0
                    ? form?.evaluate_forms[0]?.details[i]?.score
                    : ""
                }}
              </div>
              <!-- sub detail -->
              <div
                style="height: 50px"
                v-for="(sub, j) in item.sub_details"
                :key="j"
                class="text-center d-flex align-center justify-center"
              >
                <span>
                  {{
                    form?.evaluate_forms[0]?.details[i]?.sub_details[j]?.score
                  }}
                </span>
              </div>
            </td>

            <!-- ผชช.2 -->
            <td
              class="text-center py-3"
              style="
                border-right: thin solid #d3d3d3;
                border-bottom: 1px solid #d3d3d3;
              "
              width="5%"
            >
              <!-- main detail -->
              <div style="height: 40px">
                {{
                  form?.evaluate_forms[1]?.details[i]?.sub_details?.length == 0
                    ? form?.evaluate_forms[1]?.details[i]?.score
                    : ""
                }}
              </div>
              <!-- sub detail -->
              <div
                style="height: 50px"
                v-for="(sub, j) in item.sub_details"
                :key="j"
                class="text-center d-flex align-center justify-center"
              >
                <span>
                  {{
                    form?.evaluate_forms[1]?.details[i]?.sub_details[j]?.score
                  }}
                </span>
              </div>
            </td>

            <!-- ผชช.3 -->
            <td
              class="text-center py-3"
              style="
                border-right: thin solid #d3d3d3;
                border-bottom: 1px solid #d3d3d3;
              "
              width="5%"
            >
              <!-- main detail -->
              <div style="height: 40px">
                {{
                  form?.evaluate_forms[2]?.details[i]?.sub_details?.length == 0
                    ? form?.evaluate_forms[2]?.details[i]?.score
                    : ""
                }}
              </div>
              <!-- sub detail -->
              <div
                style="height: 50px"
                v-for="(sub, j) in item.sub_details"
                :key="j"
                class="text-center d-flex align-center justify-center"
              >
                <span>
                  {{
                    form?.evaluate_forms[2]?.details[i]?.sub_details[j]?.score
                  }}
                </span>
              </div>
            </td>

            <!-- ผชช.4 -->
            <td
              class="text-center py-3"
              style="
                border-right: thin solid #d3d3d3;
                border-bottom: 1px solid #d3d3d3;
              "
              width="5%"
            >
              <!-- main detail -->
              <div style="height: 40px">
                {{
                  form?.evaluate_forms[3]?.details[i]?.sub_details?.length == 0
                    ? form?.evaluate_forms[3]?.details[i]?.score
                    : ""
                }}
              </div>
              <!-- sub detail -->
              <div
                style="height: 50px"
                v-for="(sub, j) in item.sub_details"
                :key="j"
                class="text-center d-flex align-center justify-center"
              >
                <span>
                  {{
                    form?.evaluate_forms[3]?.details[i]?.sub_details[j]?.score
                  }}
                </span>
              </div>
            </td>

            <!-- ผชช.5 -->
            <td
              class="text-center py-3"
              style="
                border-right: thin solid #d3d3d3;
                border-bottom: 1px solid #d3d3d3;
              "
              width="5%"
            >
              <!-- main detail -->
              <div style="height: 40px">
                {{
                  form?.evaluate_forms[4]?.details[i]?.sub_details?.length == 0
                    ? form?.evaluate_forms[4]?.details[i]?.score
                    : ""
                }}
              </div>
              <!-- sub detail -->
              <div
                style="height: 50px"
                v-for="(sub, j) in item.sub_details"
                :key="j"
                class="text-center d-flex align-center justify-center"
              >
                <span>
                  {{
                    form?.evaluate_forms[4]?.details[i]?.sub_details[j]?.score
                  }}
                </span>
              </div>
            </td>

            <!-- คะเเนนเฉลี่ย -->
            <td
              class="text-center"
              width="10%"
              style="border-bottom: 1px solid #d3d3d3"
            >
              <!-- main detail -->
              <div style="height: 40px">
                {{
                  form?.evaluate_forms[0]?.details[i]?.sub_details?.length ==
                    0 &&
                  form?.evaluate_forms[1]?.details[i]?.sub_details?.length ==
                    0 &&
                  form?.evaluate_forms[2]?.details[i]?.sub_details?.length ==
                    0 &&
                  form?.evaluate_forms[3]?.details[i]?.sub_details?.length ==
                    0 &&
                  form?.evaluate_forms[4]?.details[i]?.sub_details?.length == 0
                    ? avgEvaluateFormDetail(
                        form?.evaluate_forms[0]?.details[i]?.score,
                        form?.evaluate_forms[1]?.details[i]?.score,
                        form?.evaluate_forms[2]?.details[i]?.score,
                        form?.evaluate_forms[3]?.details[i]?.score,
                        form?.evaluate_forms[4]?.details[i]?.score
                      )
                    : ""
                }}
              </div>
              <!-- sub detail -->
              <div
                style="height: 50px"
                v-for="(sub, j) in item.sub_details"
                :key="j"
                class="text-center d-flex align-center justify-center"
              >
                {{
                  avgEvaluateFormSubDetail(
                    form?.evaluate_forms[0]?.details[i]?.sub_details[j]?.score,
                    form?.evaluate_forms[1]?.details[i]?.sub_details[j]?.score,
                    form?.evaluate_forms[2]?.details[i]?.sub_details[j]?.score,
                    form?.evaluate_forms[3]?.details[i]?.sub_details[j]?.score,
                    form?.evaluate_forms[4]?.details[i]?.sub_details[j]?.score
                  )
                }}
              </div>
            </td>
          </tr>

          <!-- รวมคะเเนน -->
          <tr>
            <td style="border-right: thin solid #d3d3d3"></td>
            <td style="border-right: thin solid #d3d3d3" class="text-center">
              <span class="mr-2">รวมคะเเนน</span>
            </td>
            <td style="border-right: thin solid #d3d3d3" class="text-center">
              <span class="text__orange">
                {{ form?.plan?.evaluate_layout?.overall_score }}
              </span>
            </td>
            <td style="border-right: thin solid #d3d3d3" class="text-center">
              {{ sumScore(0) }}
            </td>
            <td style="border-right: thin solid #d3d3d3" class="text-center">
              {{ sumScore(1) }}
            </td>
            <td style="border-right: thin solid #d3d3d3" class="text-center">
              {{ sumScore(2) }}
            </td>
            <td style="border-right: thin solid #d3d3d3" class="text-center">
              {{ sumScore(3) }}
            </td>
            <td style="border-right: thin solid #d3d3d3" class="text-center">
              {{ sumScore(4) }}
            </td>
            <td class="text-center">
              {{ numberDecimal(sum_result) }}
            </td>
          </tr>
        </tbody>
      </table>
    </v-card>

    <div class="font-14 font-w-500 font-ch mb-5" style="color: #f15a29">
      หมายเหตุ : แบบประเมินหากทำการลงคะเเนนแล้วไม่สามารถแก้ไขได้
    </div>
  </div>
</template>

<script>
import Service from "../../services";
import { Icon } from "@iconify/vue2";

export default {
  name: "ConsiderResult",
  components: {
    Icon,
  },
  data() {
    return {
      form: null,

      sum_result: 0,
    };
  },
  created() {
    this.fetchForm();
  },
  methods: {
    fetchForm() {
      Service.Consider.getEvaluateSummary(this.$route.params.form_b_id).then(
        (res) => {
          this.form = res.data.data;

          // sum result
          this.form?.plan.evaluate_layout.details.forEach((detail, i) => {
            this.sum_result += parseFloat(
              this.avgEvaluateFormDetail(
                this.form?.evaluate_forms[0]?.details[i]?.score,
                this.form?.evaluate_forms[1]?.details[i]?.score,
                this.form?.evaluate_forms[2]?.details[i]?.score,
                this.form?.evaluate_forms[3]?.details[i]?.score,
                this.form?.evaluate_forms[4]?.details[i]?.score
              )
            );
          });
        }
      );
    },
    avgEvaluateFormDetail(val1 = 0, val2 = 0, val3 = 0, val4 = 0, val5 = 0) {
      return (
        (val1 + val2 + val3 + val4 + val5) /
        this.form.evaluate_forms.length
      ).toFixed(2);
    },
    avgEvaluateFormSubDetail(val1 = 0, val2 = 0, val3 = 0, val4 = 0, val5 = 0) {
      let sum =
        (val1 + val2 + val3 + val4 + val5) / this.form.evaluate_forms.length;
      // this.sum_result = this.sum_result + sum;

      return sum.toFixed(2);
    },
    sumTotalScore() {
      let sum = 0;
      this.form?.evaluate_forms?.forEach((item, index) => {
        sum += parseFloat(item.total_score);
      });
      return sum == 0 ? "" : (sum / this.form.evaluate_forms.length).toFixed(2);
    },
    sumScore(index) {
      let sum = 0;
      this.form.plan.evaluate_layout.details.forEach((item, i) => {
        if (this.form?.evaluate_forms[index]) {
          sum += parseFloat(this.form.evaluate_forms[index]?.details[i]?.score);
        }
      });

      return sum == 0 ? "" : sum;
    },
    onViewConsiderForm(index) {
      if (this.form.evaluate_forms[index]) {
        this.$router.push({
          name: "EvaluateView",
          params: {
            id: this.form.evaluate_forms[index].id,
          },
        });
      }
    },
    numberDecimal(val) {
      return val.toFixed(2);
    },
  },
};
</script>

<style lang="scss">
.consider__plan__form {
  .section_form {
    background: #ffffff;
    box-shadow: 1px 1px 30px rgba(0, 0, 0, 0.1) !important;
    border-radius: 20px;
  }
  .text__orange {
    color: #f15a29;
  }
  .custom_table {
    border: thin solid #d3d3d3;
  }

  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    /* display: none; <- Crashes Chrome on hover */
    -webkit-appearance: none;
    margin: 0; /* <-- Apparently some margin are still there even though it's hidden */
  }

  input[type="number"] {
    -moz-appearance: textfield; /* Firefox */
  }
  .btn_orange_gradient {
    background: linear-gradient(21.01deg, #f15a29 6.18%, #fbb040 84.83%);
    box-shadow: 1px 1px 10px rgba(0, 0, 0, 0.25);
    border-radius: 30px;
  }
  .v-text-field__slot {
    input {
      text-align: center !important;
    }
  }
  .custom_table {
    width: 100%;
    border-spacing: 0px;
    th {
      padding: 10px;
      border-bottom: 1px solid #d3d3d3;
    }
    td {
      padding: 10px;
    }
  }

  .header_link:hover {
    color: #f15a29;
    cursor: pointer;
  }
}
</style>
